import { scroller } from 'react-scroll';

export const scrollToElement = element => {
  if (!element) return;
  const offset = typeof window !== 'undefined' && window.innerWidth <= 768 ? 0 : -100;
  scroller.scrollTo(element.replace('#', ''), {
    smooth: true,
    offset,
  });
};

export const sanitizeContent = (array, ...ids) =>
  ids.reduce((red, id) => ({ ...red, [id]: array.filter(({ identifier }) => identifier.toLowerCase().endsWith(id.toLowerCase())) }), {});



// WEBPACK FOOTER //
// ./src/utils/index.js